export const categoryMenuSearchBoxPlaceholderText = "KUb";
export const categoryMenuNewCategoryTooltipText = "LUb";
export const categoryMenuNewCategoryText = "MUb";
export const categoryMenuAllCategoriesTooltip = "NUb";
export const categoryMenuAllCategoriesText = "OUb";
export const categoryMenuClearCategoriesText = "PUb";
export const categoryMenuClearCategoriesTooltipText = "QUb";
export const categoryMenuManageCategoriesTooltipText = "RUb";
export const categoryMenuManageCategoriesText = "SUb";
export default {categoryMenuSearchBoxPlaceholderText,categoryMenuNewCategoryTooltipText,categoryMenuNewCategoryText,categoryMenuAllCategoriesTooltip,categoryMenuAllCategoriesText,categoryMenuClearCategoriesText,categoryMenuClearCategoriesTooltipText,categoryMenuManageCategoriesTooltipText,categoryMenuManageCategoriesText};